import React, { PureComponent } from 'react';

import { Button } from 'components/button';
import { I18n } from 'components/translate';
import { PlayerService } from 'modules/player';
import SubtitleActions from 'modules/subtitle/SubtitleActions';
import PropTypes from 'prop-types';

import SubtitleCard from './SubtitleCard';

import SubtitleSupportedTranscriptionLangs from '../SubtitleSupportedTranscriptionLangs';

export default class SubtitleTranscribeBanner extends PureComponent {
  state = {
    selectedLang: null
  };

  static propTypes = {
    mediaId: PropTypes.string,
    setOriginalLanguage: PropTypes.func
  };

  get isSelectedLangEmpty() {
    const { selectedLang } = this.state;

    return selectedLang === null;
  }

  render() {
    const { mediaId } = this.props;

    return (
      <SubtitleCard medium className="subtitle__transcribe__banner">
        <SubtitleCard.Header label="player_subtitles.transcribe.label" />

        <SubtitleCard.Content>
          <p className="subtitle__transcribe__description">
            <I18n label="player_subtitles.transcribe.description_1" />
            <br />
            <I18n label="player_subtitles.transcribe.description_2" />
          </p>

          <div className="subtitle__transcribe__footer">
            <SubtitleSupportedTranscriptionLangs
              mediaId={mediaId}
              onSelectLang={this.setSelectedLang}
              placeholder="player_subtitles.video_language"
            />

            <Button
              onClick={this.onTranscribe}
              size="small"
              outline
              type="button"
              disabled={this.isSelectedLangEmpty}
            >
              <I18n label="player_subtitles.transcribe.cta" />
            </Button>
          </div>
        </SubtitleCard.Content>
      </SubtitleCard>
    );
  }

  onTranscribe = async () => {
    const { mediaId, setOriginalLanguage } = this.props;
    const { selectedLang } = this.state;

    await PlayerService.updateOriginalLanguage(mediaId, selectedLang);
    await SubtitleActions.transcribeMedia(mediaId);

    setOriginalLanguage(selectedLang);
  };

  setSelectedLang = (value) => this.setState({ selectedLang: value });
}
